import React, {useMemo} from 'react';
import {Select, SelectProps} from '@innowise-group/ui-kit';
import {useTranslation} from 'react-i18next';
import {RequestsStatuses, RequestStatusesEnum} from '../../core';
import {internationalizeStatus} from '../../../modules/requests/utilities';

const RequestStatusSelect: React.FC<SelectProps> = ({defaultValue, ...props}) => {
  const {t} = useTranslation();

  const items = useMemo<{value: string; title: string}[]>(() => {
    return RequestsStatuses.filter((status) => status !== RequestStatusesEnum.Delayed).map((status) => {
      const internationalizedStatus = internationalizeStatus(status);
      return {
        value: status,
        title: t(`pages.requests.${internationalizedStatus}`),
      };
    });
  }, [t]);

  const transformValue = (value) => {
    return items.find((item) => item.value === value)?.title || null;
  };

  return (
    <Select
      options={items}
      valueTransformer={transformValue}
      placeholder={t('placeholders.status')}
      position="fixed"
      {...props}
    />
  );
};

export default RequestStatusSelect;
